import { render, staticRenderFns } from "./HeaderImageSelector.vue?vue&type=template&id=225e0e81&scoped=true&"
import script from "./HeaderImageSelector.vue?vue&type=script&lang=js&"
export * from "./HeaderImageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225e0e81",
  null
  
)

export default component.exports